import { jsx } from "react/jsx-runtime";
import { Box } from "../../Box/Box.mjs";
import { useIcon } from "../../../hooks/useIcon/index.mjs";
import { IconHome2Svg } from "./IconHome2Svg.mjs";
const IconHome2 = (props) => {
  const iconProps = useIcon(props);
  return /* @__PURE__ */ jsx(Box, { component: IconHome2Svg, ...iconProps });
};
export {
  IconHome2
};
